import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/home/ubuntu/download_production/69d1713034b9ae001473d385/vocedlms/node_modules/sonner/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["RoleProvider"] */ "/home/ubuntu/download_production/69d1713034b9ae001473d385/vocedlms/src/context/RoleContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/home/ubuntu/download_production/69d1713034b9ae001473d385/vocedlms/src/contexts/AuthContext.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69d1713034b9ae001473d385/vocedlms/src/styles/tailwind.css");
